// extracted by mini-css-extract-plugin
export default {"image":"ViewImages_image__iyff2","modal":"ViewImages_modal__5rFM9"};